import api from "./index";
import { ENDPOINTS } from "./endpoints";

/* CREATE */
export const createSpecValue = (data)=>{
  return api.post(ENDPOINTS.SPEC_VALUES.BASE,data);
};

/* SEARCH */
export const listSpecValueByParams = (data)=>{
  return api.post(ENDPOINTS.SPEC_VALUES.SEARCH,data);
};

/* GET */
export const getSpecValueById = (id)=>{
  return api.get(ENDPOINTS.SPEC_VALUES.BY_ID(id));
};

/* UPDATE */
export const updateSpecValue = (id,data)=>{
  return api.put(ENDPOINTS.SPEC_VALUES.BY_ID(id),data);
};

/* DELETE */
export const deleteSpecValue = (id)=>{
  return api.delete(ENDPOINTS.SPEC_VALUES.BY_ID(id));
};

/* SPEC TYPE DROPDOWN */
export const specTypeDropdown = ()=>{
  return api.get(ENDPOINTS.SPEC_VALUES.SPEC_TYPE_DROPDOWN);
};